/**
 * Sélecteur d'environnement de l'en-tête (pastille colorée) — extrait de
 * Layout.tsx, déplacement pur.
 */
import React from 'react';
import { Chip, FormControl, MenuItem, Select } from '@mui/material';
import { useEnvironment } from '../../contexts/EnvironmentContext';
import { AppEnvironment, AVAILABLE_ENVIRONMENTS, ENVIRONMENT_META } from '../../config/environment';

/** Largeur minimale du sélecteur (px). */
const SELECTOR_MIN_WIDTH = 110;

/** Pastille d'un environnement. */
const EnvironmentChip: React.FC<{ env: AppEnvironment }> = ({ env }) => (
  <Chip label={ENVIRONMENT_META[env].label} color={ENVIRONMENT_META[env].color} size="small" sx={{ cursor: 'pointer' }} />
);

/** Choix de l'environnement de l'onglet (test / preprod / prod selon le build). */
const EnvironmentSelector: React.FC = () => {
  const { environment, setEnvironment } = useEnvironment();
  return (
    <FormControl size="small" variant="standard" sx={{ minWidth: SELECTOR_MIN_WIDTH, mr: 2 }}>
      <Select
        value={environment}
        onChange={(e) => setEnvironment(e.target.value as AppEnvironment)}
        disableUnderline
        renderValue={(value) => <EnvironmentChip env={value as AppEnvironment} />}
        sx={{ color: 'inherit', '& .MuiSelect-icon': { color: 'inherit' } }}
      >
        {AVAILABLE_ENVIRONMENTS.map((env) => (
          <MenuItem key={env} value={env}>
            <EnvironmentChip env={env} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default EnvironmentSelector;
